import { useEffect, useState } from "react";
import Loading from "../loading/Loading";
import { Link, useParams } from "react-router-dom";
import { Alert, Button, Table } from "react-bootstrap";
import { getComunidadOrderHistory, getDiocesisOrderHistory, getOrderReceiptUrl, getRegionOrderHistory } from "../../controllers/orders";
import OrderDetailsModal from "../orders/OrderDetailsModal";
import OrderPaymentModal from "../orders/OrderPaymentModal";

function ComunidadOrderHistory({ type }) {
  const params = useParams();
  const [orders, setOrders] = useState();
  const [showPayModal, setShowPayModal] = useState(false);
  const [modalOrder, setModalOrder] = useState();

  let orgId;
  switch (type) {
    case 'region': orgId = params.regionId; break;
    case 'diocesis': orgId = params.diocesisId; break;
    case 'comunidad': orgId = params.comunidadId; break;
    default: orgId = null;
  }

  useEffect(() => {
    loadHistory();
  }, []);

  async function loadHistory() {
    let o;
    switch (type) {
      case 'region': o = await getRegionOrderHistory(orgId, 'material'); break;
      case 'diocesis': o = await getDiocesisOrderHistory(orgId, 'material'); break;
      case 'comunidad': o = await getComunidadOrderHistory(orgId, 'material'); break;
      default: orgId = null;
    }
    setOrders(o);
  }

  if (!orders) {
    return <Loading />
  }
  else if (!orders.length) {
    return <Alert variant="warning">No se encontraron órdenes.</Alert>
  }

  function showModal(e) {
    e.preventDefault();
    let o = orders.find(or => or.order_id === parseInt(e.target.dataset.order_id));
    setModalOrder(o);
    setShowPayModal(false);
  }
  function hideModal() {
    setModalOrder(false);
  }
  function launchPayModal() {
    setShowPayModal(true);
  }
  function showPaymentModal(e) {
    showModal(e);
    launchPayModal();
  }
  async function onPayment() {
    console.log(`modal order: ${modalOrder.order_id}`);
    loadHistory();
  }

  async function downloadReceipt(orderId) {
    const win = window.open('', '_blank');
    if (!win) {
      window.alert('No se pudo abrir la ventana para mostrar el recibo. Verifica el bloqueador de popups.');
      return;
    }
    win.document.write('<!doctype html><html><head><meta charset="utf-8"/><title>Generando recibo...</title></head><body style="font-family: sans-serif; padding: 24px;">Generando recibo...</body></html>');
    win.document.close();

    try {
      const receipt = await getOrderReceiptUrl(orderId);

      if (receipt?.source === 'stripe' && receipt?.receiptUrl) {
        win.location.href = receipt.receiptUrl;
        return;
      }

      if (receipt?.source === 'internal' && receipt?.html) {
        win.document.open();
        win.document.write(receipt.html);
        win.document.close();
        return;
      }

      // Backward compatibility if API returns plain URL string
      if (typeof receipt === 'string' && receipt) {
        win.location.href = receipt;
        return;
      }

      win.close();
      window.alert('No fue posible obtener el recibo de la orden.');
    }
    catch (e) {
      win.close();
      window.alert(e?.message || 'No fue posible obtener el recibo de la orden.');
    }
  }

  function renderOrders() {
    return orders.map((o, i) => {
      let fecha = new Date(o.createdAt);
      let total = 0;
      o.line_items.forEach(li => {
        total += parseInt(li.product_original_price) * li.quantity;
      });
      let payButton = '';
      if (o.order_status === 'Pago pendiente') {
        payButton = <Button variant="primary" data-order_id={o.order_id} onClick={showPaymentModal}>Pagar</Button>
      }
      let receiptButton = '';
      if (o.order_status === 'Pagada') {
        receiptButton = <Button variant="outline-primary" size="sm" onClick={() => downloadReceipt(o.order_id)}>Descargar recibo</Button>
      }
      return <tr key={`order-${o.order_id}`}>
        <td>{o.order_id}</td>
        <td>{fecha.toLocaleDateString()} {fecha.toLocaleTimeString()}</td>
        <td>{o.order_status}</td>
        <td>${total}</td>
        <td>
          {payButton} {receiptButton} <Link onClick={showModal} data-order_id={o.order_id}>Ver detalles</Link>
        </td>
      </tr>
    });
  }

  return <>
    <Table striped hover>
      <thead>
        <tr>
          <td>Número de orden</td>
          <td>Fecha</td>
          <td>Estatus</td>
          <td>Monto</td>
          <td>Acciones</td>
        </tr>
      </thead>
      <tbody>
        {renderOrders()}
      </tbody>
    </Table>
    <OrderDetailsModal
      show={!!modalOrder && !showPayModal} 
      handleClose={hideModal} 
      handlePay={modalOrder?.order_status === 'Pago pendiente' ? launchPayModal : null}
      handleDownloadReceipt={modalOrder?.order_status === 'Pagada' ? () => downloadReceipt(modalOrder.order_id) : null}
      order={modalOrder}
    />
    <OrderPaymentModal 
      show={!!modalOrder && showPayModal} 
      handleClose={hideModal} 
      onPayment={onPayment}
      order={modalOrder}
    />
  </>;
}

export default ComunidadOrderHistory;